import styled, { css } from "styled-components";
export const Container = styled.div`
  height: 97%;
  overflow-y: auto;
`;

export const InputStyled = styled.input`
  width: 70%;
  padding: 10px;
  background-color: rgba(42, 46, 67, 0.05);
  border-radius: 8px;
`;
export const SelectBtnStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45%;
  padding: 10px;
  background-color: ${(props) =>
    props.selected ? "rgba(42, 46, 67, 0.05);" : "#2a2e43"};
  color: ${(props) => (props.selected ? "#2a2e43" : "#fff")};
  border-radius: 8px;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const InputُTextAreaStyled = styled.textarea`
  width: 70%;
  padding: 10px;
  background-color: rgba(42, 46, 67, 0.05);
  border-radius: 8px;
  border: transparent;
  height: 100px;
`;
export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
`;
export const InputTextContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: right;
  padding: 10px;
  width: 30%;
  font-size: 12px;
  font-weight: 999;
  color: #353a50;
`;
export const InputDateContainer = styled.div`
  display: flex;
  width: 70%;
  justify-content: space-between;
`;
export const ImageInputContainerStyled = styled.div`
  width: 70%;
  padding: ${(props) => (props.cardmelli_img ? "0" : "10px")};
  background-color: ${(props) =>
    props.cardmelli_img ? "transparent" : "rgba(42, 46, 67, 0.05)"};
  border-radius: 8px;
  /* border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px; */
  cursor: pointer;
`;
export const ImageInputWithImageStyled = styled.input`
  cursor: pointer;
  color: transparent;
  width: 100%;
  background: transparent;
  background-image: url(${(props) => props.url});
  height: 15vh;
  border-radius: 8px;
  background-size: cover;
`;
export const ImageInputStyled = styled.input`
  cursor: pointer;
  color: transparent;
  width: 100%;
  background: transparent;
  height: 10vh;
  border-radius: 8px;
  background-size: cover;
`;
export const UserTypesTextStyled = styled.div`
  padding: 16px;
  font-size: 16px;
  font-weight: 999;
`;
export const SubmitBtn = styled.div`
  padding: 10px 24px;
  color: white;
  border-radius: 10px;
  font-size: 1.33333em;
  box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.25);
  font-weight: bold;
  background-color: #ffbf1d;
  width: 70%;
  text-align: center;
`;
export const SubmitBtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
`;
export const AlertStyled = styled.div`
  padding: 10px 24px;
  border-radius: 10px;
  color: white;
  background-color: #bd2130;
  width: 70%;
  text-align: center;
  font-weight: bold;
`;
